import React from "react";
import Header from "../components/Header";
import ListBook from "../components/ListBook";


const Home = () => {
  return (
    <div>
        <Header />
        <ListBook />
        
    </div>
  )
}

export default Home;
